import axios from "axios"; 

const LocationNotOffService = {
  // Fetch all 
  async getAll(date) {
    try {
      const response = await axios.get(`/LocationNotOff/GetLocationNotOff?p_date=${date}`, {
        // const response = await axios.get(`http://localhost:51976/LocationNotOff/GetLocationNotOff?p_date=${date}`, {
        headers: {
          
        },
      });

      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching purchase orders:", error);
      throw error;
    }
  },
}

export default LocationNotOffService;
